

import request from '@/plugins/request'

export function getParentNodes(pageindex, pagesize) {
    return request({
        url: '/v1/Tree/GetParentNodes',
        method: 'post',
        data: {
            pageIndex: pageindex,
            pageSize: pagesize
        }
    })
}

export function getChildNodesByParentId(parentId, pageindex, pagesize) {
    return request({
        url: '/v1/Tree/GetChildNodesByParentId',
        method: 'post',
        data: {
            id: parentId,
            pageIndex: pageindex,
            pageSize: pagesize
        }
    })
}
export function searchNodes(keyword, pageindex, pagesize) {
    return request({
        url: '/v1/Tree/SearchNodes',
        method: 'post',
        data: {
            keyword: keyword,
            pageIndex: pageindex,
            pageSize: pagesize
        }
    })
}